import React, { Dispatch, SetStateAction } from "react";
import { changeNumComma } from "../../../../../AdminApi/commFunc";
import { Input } from "../../../../Input/Input";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { ValueContainer } from "../CouponPointRegisterModal";

interface RandomDeductProps {
  inputPointValue: string;
  setInputPointValue: Dispatch<SetStateAction<string>>;
}

export default function RandomDeduct({
  inputPointValue,
  setInputPointValue,
}: RandomDeductProps) {
  return (
    <>
      <ModalRow>
        <ModalLabel>차감 포인트</ModalLabel>

        <ValueContainer>
          <Input
            placeholder="직접 입력"
            value={inputPointValue}
            onChange={(e) =>
              setInputPointValue(changeNumComma(e).toLocaleString("ko"))
            }
            type="text"
            inputMode="numeric"
            style={{ width: "100%" }}
          />
        </ValueContainer>
      </ModalRow>
    </>
  );
}
